/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Rep_Max_EstimatedInputs */

const en_us2_exercise_sheet_rep_max_estimated = /** @type {(inputs: Exercise_Sheet_Rep_Max_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated`)
};

const pt_br2_exercise_sheet_rep_max_estimated = /** @type {(inputs: Exercise_Sheet_Rep_Max_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimado`)
};

const es_419_exercise_sheet_rep_max_estimated = /** @type {(inputs: Exercise_Sheet_Rep_Max_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimado`)
};

const pt_pt2_exercise_sheet_rep_max_estimated = /** @type {(inputs: Exercise_Sheet_Rep_Max_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimado`)
};

const fr_fr2_exercise_sheet_rep_max_estimated = /** @type {(inputs: Exercise_Sheet_Rep_Max_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimé`)
};

const de_de2_exercise_sheet_rep_max_estimated = /** @type {(inputs: Exercise_Sheet_Rep_Max_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzt`)
};

const it_it2_exercise_sheet_rep_max_estimated = /** @type {(inputs: Exercise_Sheet_Rep_Max_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimato`)
};

/**
* | output |
* | --- |
* | "Estimated" |
*
* @param {Exercise_Sheet_Rep_Max_EstimatedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_rep_max_estimated = /** @type {((inputs?: Exercise_Sheet_Rep_Max_EstimatedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Rep_Max_EstimatedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_rep_max_estimated(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_rep_max_estimated(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_rep_max_estimated(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_rep_max_estimated(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_rep_max_estimated(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_rep_max_estimated(inputs)
	return en_us2_exercise_sheet_rep_max_estimated(inputs)
});
export { exercise_sheet_rep_max_estimated as "exercise-sheet.rep_max_estimated" }